<template>
  <div class="panel">
    <Title :title="data.themeName" />
    <div class="list clearfix">
      <template v-for="(item, index) in data.goodsList">
        <Item
          :data="item"
          :actThemeId="data.actThemeId"
          :index="index"
          :key="item.dataId"
          :targetPrice="targetPrice"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Title from '@/components/activity/Title'
import Item from './Item'
export default {
  name: 'panel',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    targetPrice: {
      type: [String, Number],
      required: true,
    },
  },
  components: { Title, Item },
}
</script>

<style lang="less" scoped>
.panel {
  .title {
    padding: 30px 30px;
  }
  .list {
    padding: 0 20px;
    .item {
      float: left;
      width: 32%;
      margin-right: 2%;
      margin-bottom: 2.2%;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
